export enum SecondaryPopUpField {
    ReconcileReasonId = 0,
    RefusalChoiceId = 1,
    ReturnSticker = 2,
    NoReturnSticker = 3,
    Comments = 4,
    CodeDate = 5,
    AddCatchWeight = 6,
}